import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoginService } from 'src/app/services/login/login.service';
import { Router } from '@angular/router';
import { HelperService } from '../../../services/helper/helper.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  useEmail: string = this.helperService.getUseEmail();
  userRoleStorage:string = this.helperService.getUserRoles()[0].authority;
  userRole:string = '';
  rucCompany: string = this.helperService.getRucCompany();
  RazCompany: string = this.helperService.getRazSocialCompany();
  UserName: string = this.helperService.getUseName();
  UseLastName: string = this.helperService.getUseLastName();
  public showPopup: boolean = false;
  isDropdownOpen: boolean = false;
  isSidebarOpened: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private loginService: LoginService,
    private router: Router,
    private helperService: HelperService,
    private elemenRef: ElementRef
  ) { }

  bodyElement: HTMLElement = this.document.body;

  ngOnInit(): void {
    this.identifyRole();
  }

  toggleDropdown(event: Event): void {
    event.preventDefault();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  preventClosing(event: Event): void {
    event.stopPropagation();
  }
  toogleOpened(): void {
    this.isSidebarOpened = !this.isSidebarOpened;
    this.bodyElement.classList.toggle('toggle-sidebar');
  }

  logOut(): void {
    this.loginService.logout();
    this.router.navigateByUrl('/');
  }

  showPop() {
    console.log("La función showPop() se está llamando correctamente.");
    this.isDropdownOpen = true;
    this.showPopup = true;
    console.log("El valor de showPopup después de establecerlo en true es:", this.showPopup);
  }

  mostrarMenu() {
    // Agrega la lógica para mostrar el menú desplegable
    document.querySelector('.dropdown-menu').classList.add('show');
  }

  closePopup() {
    this.showPopup = false;
  }
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }
  goToWtsp(): void {
    // Define el enlace que quieres abrir en la nueva ventana
    const enlace = 'http://wa.me/+51938648117';

    // Abre una nueva ventana con el enlace especificado
    window.open(enlace, '_blank');
  }

  identifyRole():void{
    switch(this.userRoleStorage){
      case "ROLE_ADMIN":{
        this.userRole = 'Administrador';
        break;
      }
      case "ROLE_WAITER":{
        this.userRole = 'Mozo';
        break;
      }
      case "ROLE_CASHIER":{
        this.userRole = 'Cajero';
        break;
      }
      case "ROLE_CHEF":{
        this.userRole = 'Cocinero';
        break;
      }
      default:{
        this.userRole = 'usuario';
        break;
      }
    }
  }
}
